import React, {Component} from 'react';
import {API_URL} from "../../../settings/local_settings";
import {APIClient} from "../../../utils/APIClient";
import {DashboardTodayCell} from "./cells/DashboardTodayCell";
import {DashboardFullPeriodBudgetProportionalCell} from "./cells/with_bars/DashboardFullPeriodBudgetProportionalCell";
import {DashboardFullPeriodODSCell} from "./cells/single_value/DashboardFullPeriodODSCell";
import {DashboardFullPeriodODSVsSomethingCell} from "./cells/value_vs_expected/DashboardFullPeriodODSVsSomethingCell";
import {DashboardFullPeriodConversionsCell} from "./cells/with_bars/DashboardFullPeriodConversionsCell";
import {
    CURRENT_PERIOD_CPA_VS_COLUMNS,
    FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN,
    FULL_PERIOD_CONVERSIONS_COLUMN,
    CURRENT_PERIOD_CPA_COLUMN,
    FULL_PERIOD_ODS_COLUMN,
    FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN,
    INDICATORS_COLUMNS,
    LABELS_COLUMN,
    LAST_PERIOD_BUDGET_DATA,
    CURRENT_PERIOD_ALLOCATED_BUDGET_COLUMN,
    CURRENT_PERIOD_PERIOD_DATES_COLUMN,
    CURRENT_PERIOD_BUDGET_DATA,
    TODAY_COLUMNS,
    YESTERDAY_CPA_VS_COLUMNS,
    YESTERDAY_EXPENSES_COLUMN,
    PURCHASES_VALUE_COLUMN,
    LAST_PERIOD_PURCHASES_VALUE_COLUMN,
    ROAS_COLUMN,
    ACOS_COLUMN,
    FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN,
    FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN,
    ONLY_FOR_BU_NOT_BUCC_COLUMN,
    CURRENCY_COLUMN,
    CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN,
    CURRENT_PERIOD_TIME_COMPLETION_COLUMN,
    CURRENT_PERIOD_COST_VS_TIME_COLUMN,
    AVAILABLE_FUNDS_COLUMN,
    COMMENTS_COLUMN,
    PLATFORM_BUDGET_COLUMN,
    CAMPAIGN_STATUS_COLUMN,
    DAYS_TILL_FUNDS_ARE_OUT_COLUMN,
    AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN,
    LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN,
    FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN,
    GOAL_1_COLUMN,
    GOAL_2_COLUMN,
    FLEX_INDICATOR_COLUMN_TO_DATA,
    getPeriodsData,
    CAMPAIGN_AND_ADGROUP_ROW_EXCLUDED_COLUMNS,
    NO_COMPARATION_PERIOD, GOAL_1_INFO_COLUMN, GOAL_2_INFO_COLUMN,
    getColumnHeaderInformation
} from "../columns";
import {CHANNEL_INFO_BY_CHANNEL, ChannelsHelper} from "../../channels/channels";
import {DashboardFullPeriodYesterdayCell} from "./cells/single_value/DashboardFullPeriodYesterdayCell";
import {DashboardLabelsCell} from "./cells/DashboardLabelsCell";
import {BusinessUnitNameCell} from "./BusinessUnitNameCell";
import {DashboardSingleValueCell} from "./cells/base/DashboardSingleValueCell";
import {METRICS_WITH_POTENTIAL_EMPTY_VALUES} from "../metrics";
import {DashboardBudgetCell} from "./cells/DashboardBudgetCell";
import {DashboardYesterdayCPAVsPeriodCell} from "./cells/value_vs_expected/DashboardYesterdayCPAVsPeriodCell";
import {DashboardCurrentCPAVsPeriodCell} from "./cells/value_vs_expected/DashboardCurrentCPAVsPeriodCell";
import {WebSocketChannels, WebSocketEvents} from "../../../websockets/WebSocketsClient";
import {WebSocketEvent} from "../../../websockets/WebSocketEvent";
import {CellWithErrorHandler} from "./cells/CellWithErrorHandler";
import {
    DashboardFullPeriodROASVsLastPeriodCell
} from "./cells/value_vs_expected/DashboardFullPeriodROASVsLastPeriodCell - copia";
import {DashboardFullPeriodACOSVsLastPeriodCell} from "./cells/value_vs_expected/DashboardFullPeriodACOSVsLastPeriodCell";
import {BusinessUnitAdAccountNameCell} from "./BusinessUnitAdAccountNameCell";
import {EmptyCell} from "./cells/base/EmptyCell";
import {DashboardAvailableFundsCell} from "./cells/DashboardAvailableFundsCell";
import {DashboardValueWithAlertCell} from "./cells/DashboardValueWithAlertCell";
import {DashboardGoalBarsCell} from "./cells/with_bars/DashboardGoalBarsCell";
import {DashboardValueVsExpectedCell} from "./cells/base/DashboardValueVsExpectedCell";
import {CampaignNameCell} from "./CampaignNameCell";
import {AdgroupNameCell} from "./AdgroupNameCell";
import {PlatformBudgetCell} from "./cells/PlatformBudgetCell";
import {CampaignStatusBadgeCell} from "./cells/CampaignStatusBadgeCell";
import {CAMPAIGN_STATUS_ACTIVE, ADGROUP_STATUS_ACTIVE} from "../../../marketing";
import {TYPE_ONE_BUDGET_PER_CAMPAIGN, TYPE_ONE_BUDGET_PER_ADGROUP} from "../../business_units/BusinessUnitTypes";
import { withTranslation } from 'react-i18next';
import {DashboardCommentsCell} from "./cells/DashboardCommentsCell";
import {DashboardCurrentCostVsTimeCell} from "./cells/value_vs_expected/DashboardCurrentCostVsTimeCell";
import {SyncingCell} from "./cells/base/SyncingCell";
import {DashboardPeriodDatesCell} from "./cells/DashboardPeriodDatesCell";
import {DashboardGoalGoalCell} from "./cells/DashboardGoalGoalCell";
import {ItemPeriodDates} from "../../../utils/ItemPeriodDates";
import {DatetimeHelper} from "../../../utils/DatetimeHelper";

export const TYPE_BUSINESS_UNIT = 'TYPE_BUSINESS_UNIT';
export const TYPE_CAMPAIGNS_CONFIGURATION = 'TYPE_CAMPAIGNS_CONFIGURATION';
export const TYPE_CAMPAIGN = 'TYPE_CAMPAIGN';
export const TYPE_ADGROUP = 'TYPE_ADGROUP';

export class DashboardRowClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            businessUnitNeverSynced: false,
            businessUnitNotStarted: false,
            businessUnitWithoutCampaignsConfiguration: false,
            downUrlsCount: this.props.downUrlsCount,
            hasUrls: this.props.hasUrls,
            syncInformation: this.props.syncInformation,
            showOldDataLayer: this.props.syncInformation && this.props.syncInformation.has_sync_problems_for_a_long_time,
            showingAdAccountsRows: false,
            loadingNotActiveCampaignsOrAdgroupByBuccId: {},
            detailsColumnData: null,
            showOnlyActiveCampaignsOrAdgroupsByBuccId: {},
            showingAdgroupsRowsByCampaignId: {}
        };

        this._adAccountsRowsBeginExpanded = null;
        // this._campaignsRowsBeingExpanded = {}; // Por adAccountId

        this.handleURLStatusChange = this.handleURLStatusChange.bind(this);
        this.handleSnoozeAllAlerts = this.handleSnoozeAllAlerts.bind(this);
        this.handleStopSnoozeForAllAlerts = this.handleStopSnoozeForAllAlerts.bind(this);
        this.handleWebSocketDataUpdateRequest = this.handleWebSocketDataUpdateRequest.bind(this);
        this.handleBusinessUnitSync = this.handleBusinessUnitSync.bind(this);
        this.handleBudgetUpdated = this.handleBudgetUpdated.bind(this);
        this.handlePeriodDatesUpdated = this.handlePeriodDatesUpdated.bind(this);
        this.handleGoalUpdated = this.handleGoalUpdated.bind(this);
        this.handleAvailableFundsUpdated = this.handleAvailableFundsUpdated.bind(this);
        this.handleCommentsUpdated = this.handleCommentsUpdated.bind(this);
        this.handleToggleAdAccountsRows = this.handleToggleAdAccountsRows.bind(this);
        this.handleOnlyActiveCampaignsOrAdgroupsChanged = this.handleOnlyActiveCampaignsOrAdgroupsChanged.bind(this);
        this.handleToggleAdgroupsRows = this.handleToggleAdgroupsRows.bind(this);
    }

    // getFromLocalStorage() {
    //     const showingCampaignRowsByBuccId = {};
    //     this.props.adAccountsData.forEach((data) => {
    //         const buccId_str = data.id.toString();
    //         const value = localStorage.getItem(`BusinessUnitIsExpanded-${this.props.businessUnitId}-${buccId_str}`);
    //         showingCampaignRowsByBuccId[buccId_str] = value !== null ? value === "true" : false;
    //     });
    //     return showingCampaignRowsByBuccId;
    // }

    componentDidMount() {
        this.getBusinessUnitData();
        //this.fetchBusinessUnitSyncStatus();
        // this.fetchBusinessUnitAlert();

        if (this._getBusinessUnitIsExpanded()) {
            this.handleToggleAdAccountsRows();
        }
    }

    // API calls

    getBusinessUnitData() {
        new APIClient(API_URL + `business-unit/${this.props.businessUnitId}/dashboard/metrics`).call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    this.props.onBusinessDataFetched(this.props.businessUnitId, response.data);
                } else if (response.status === 'ERROR_SYNC_PENDING') {
                    this.setState({businessUnitNeverSynced: true});
                } else if (response.status === 'ERROR_BU_EVENTUAL_NOT_STARTED') {
                    this.setState({businessUnitNotStarted: true});
                } else if (response.status === 'ERROR_NO_CAMPAIGNS_OR_ADGROUPS') {
                    this.setState({businessUnitWithoutCampaignsConfiguration: true});
                } else {
                    alert(response.error_message)
                }
            });
    }

    refreshAlertInfo() {
        const { t } = this.props;
        new APIClient(API_URL + `business-unit/${this.props.businessUnitId}/down-urls`).call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    this.setState({
                        downUrlsCount: response.down_urls_count,
                        hasUrls: response.has_urls,
                    });
                } else {
                    alert(response.error_message)
                }
            })
            .catch((error) => {
                alert(t('dashboard_row.error_occurred_contact_team'))
            });
    }

    fetchBusinessUnitSyncStatus() {
        new APIClient(API_URL + `business-unit/${this.props.businessUnitId}/sync-information`).call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    this.setState({
                        syncInformation: response.data
                    });
                } else {
                    alert(response.error_message);
                }
            });
    }

    // fetchBusinessUnitAlert() {
    //     const url = API_URL + `business-unit/${this.props.businessUnitId}/alerts`;
    //     new APIClient(url).call('GET')
    //         .then((response) => {
    //             if (response.status === 'OK') {
    //                 this.setState({
    //                     generalAlerts: response.data
    //                 });
    //             } else {
    //                 alert(response.error_message);
    //             }
    //         });
    // }

    fetchDetailsColumnData(callbackFunction) {
        const { t } = this.props;
        new APIClient(API_URL + `business-unit/${this.props.businessUnitId}/dashboard/campaigns_configuration/info/`).call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    this.setState({
                        detailsColumnData: response.data,
                    }, callbackFunction);
                } else {
                    alert(response.error_message)
                }
            })
            .catch((error) => {
                alert(t('dashboard_row.error_occurred_contact_team'))
            });
    }

    fetchCampaignsAndAdgroupsNotActiveData(buccId) {
        const { t } = this.props;
        const newLoadingNotActiveCampaignsOrAdgroupsByBuccId = this.state.loadingNotActiveCampaignsOrAdgroupByBuccId;
        newLoadingNotActiveCampaignsOrAdgroupsByBuccId[buccId] = true;

        this.setState({
            loadingNotActiveCampaignsOrAdgroupsByBuccId: newLoadingNotActiveCampaignsOrAdgroupsByBuccId
        });

        const url = API_URL + `campaigns-configurations/${buccId}/campaigns-and-adgroups-not-active/dashboard/info/`;
        new APIClient(url).call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    const itemsData = response.data;

                    // Se actualiza el item del bucc
                    const newDetailsColumnDataForBucc = this._getDetailsColumnDataForBusinessUnitAdAccount(buccId)
                    newDetailsColumnDataForBucc["notActiveItemsLoaded"] = true;
                    newDetailsColumnDataForBucc.campaigns_data = newDetailsColumnDataForBucc.campaigns_data.concat(itemsData["campaigns_data"]);
                    newDetailsColumnDataForBucc.adgroups_data = newDetailsColumnDataForBucc.adgroups_data.concat(itemsData["adgroups_data"]);

                    // Se mete en la lista el item actualizado pisando el viejo
                    const newDetailsColumnData = this.updateDetailsForBuccId(buccId, newDetailsColumnDataForBucc);

                    const newLoadingNotActiveCampaignsOrAdgroupByBuccId = this.state.loadingNotActiveCampaignsOrAdgroupByBuccId;
                    newLoadingNotActiveCampaignsOrAdgroupByBuccId[buccId] = false;

                    this.setState({
                        detailsColumnData: newDetailsColumnData,
                        // FEDE: aca va newLoa... o loadin...? antes estaba newLo.. pero parece un bug
                        newLoadingNotActiveCampaignsOrAdgroupByBuccId: newLoadingNotActiveCampaignsOrAdgroupByBuccId
                    });
                } else {
                    alert(response.error_message)
                }
            })
            .catch((error) => {
                alert(t('dashboard_row.error_occurred_contact_team'))
            });
    }

    updateDetailsForBuccId(buccId, newDetailsColumnDataForBucc) {
        return this.state.detailsColumnData.map((item) => {
            if(item.id !== buccId)
                return item;
            else {
                return newDetailsColumnDataForBucc;
            }
        });
    }

    // handlers

    // handleToggleCampaignsRows(buccId) {
    //     const showingCampaignRowsByBuccId = this.state.showingCampaignRowsByBuccId;
    //     const buccId_str = buccId.toString();
    //
    //     if(!showingCampaignRowsByBuccId.hasOwnProperty(buccId_str)) {
    //         showingCampaignRowsByBuccId[buccId_str] = false;
    //     }
    //
    //     // Cambia el valor
    //     showingCampaignRowsByBuccId[buccId_str]= !showingCampaignRowsByBuccId[buccId_str];
    //
    //     // Si se quiere ver el detalle y no lo tengo, lo traigo
    //     if (showingCampaignRowsByBuccId[buccId_str] && this.state.detailsColumnData === null) {
    //         this.fetchDetailsColumnData();
    //     }
    //
    //     this._setAdAccountIsExpanded(showingCampaignRowsByBuccId[buccId_str], buccId);
    //     this.setState({showingCampaignRowsByBuccId: showingCampaignRowsByBuccId});
    // }

    handleToggleAdAccountsRows() {
        const newValue = !this.state.showingAdAccountsRows

        // Si se quiere ver el detalle y no lo tengo, lo traigo
        if (newValue && this.state.detailsColumnData === null) {
            this.fetchDetailsColumnData();
        }

        this._setBusinessUnitIsExpanded(newValue);
        this.setState({showingAdAccountsRows: newValue});
    }

    handleToggleAdgroupsRows(campaignId) {
        const showingAdgroupsRowsByCampaignId = this.state.showingAdgroupsRowsByCampaignId;
        if (showingAdgroupsRowsByCampaignId[campaignId] === undefined)
            showingAdgroupsRowsByCampaignId[campaignId] = false

        showingAdgroupsRowsByCampaignId[campaignId] = !showingAdgroupsRowsByCampaignId[campaignId];

        this.setState({showingAdgroupsRowsByCampaignId: showingAdgroupsRowsByCampaignId});
    }

    syncBusinessUnitURL() {
        return `${API_URL}business-unit/${this.props.businessUnitId}/sync-manually`
    }

    handleBusinessUnitSync() {
        if (!this.state.syncInformation.is_on_sync && !this.state.syncInformation.is_being_synced_on_demand) {
            const syncBusinessUnitRequest = new APIClient(this.syncBusinessUnitURL()).call('POST');
            syncBusinessUnitRequest.then((response) => {
                if (response.status === 'OK') {
                    this.setState({
                        syncInformation: {
                            ...this.state.syncAlert,
                            is_being_synced_on_demand: true,
                        }
                    })
                }
            });
        }
    }

    handleURLStatusChange(message) {
        if (message.businessUnitId === this.props.businessUnitId) {
            this.refreshAlertInfo();
        }
    }

    handleWebSocketDataUpdateRequest(message) {
        if (message.businessUnitId === this.props.businessUnitId) {
            if(this.state.detailsColumnData !== null)
                this.fetchDetailsColumnData(this.getBusinessUnitData);
            else
                this.getBusinessUnitData();
            this.fetchBusinessUnitSyncStatus();
            // this.fetchBusinessUnitAlert();
        }
    }

    // handlers - snooze all alerts

    handleSnoozeAllAlerts() {
        this.props.onSnoozeAllAlerts(this.props.businessUnitId);
    }

    handleStopSnoozeForAllAlerts() {
        this.props.onStopSnoozeForAllAlerts(this.props.businessUnitId);
    }

    handleCommentsUpdated(campaignId, adgroupId, rowsData) {
        this._updateDetailsDataAndBusinessUnitData(campaignId, adgroupId, rowsData);
    }

    handleBudgetUpdated(campaignId, adgroupId, rowsData) {
        this._updateDetailsDataAndBusinessUnitData(campaignId, adgroupId, rowsData);
    }

    handlePeriodDatesUpdated(campaignId, adgroupId, rowsData) {
        this._updateDetailsDataAndBusinessUnitData(campaignId, adgroupId, rowsData);
    }

    getNewCampaignDataForBuccId(detailsForBucc, campaignId, dashboard) {
        return detailsForBucc.campaigns_data.map(campaign_data => {
            if (campaign_data.id !== campaignId)
                return campaign_data;
            else
                dashboard.adgroups_data = campaign_data.adgroups_data;
                return dashboard;
        });
    }

    getCampaignDataOfAdgroupId(detailsForBucc, adgroupId) {
        let theCampaignData = null;
        detailsForBucc.campaigns_data.forEach(campaignData => {
            campaignData.adgroups_data.forEach(adgroupData => {
                if(adgroupId === adgroupData.id) {
                    theCampaignData = campaignData;
                }
            });
        });

        return theCampaignData;
    }

    getNewAdgroupDataForBuccId(detailsForBucc, adgroupId, dashboard, adgroups_data) {
        return adgroups_data.map(adgroup_data => {
            if (adgroup_data.id !== adgroupId)
                return adgroup_data;
            else
                return dashboard;
        });
    }

    handleGoalUpdated(campaignId, adgroupId, rowsData) {
        this._updateDetailsDataAndBusinessUnitData(campaignId, adgroupId, rowsData);
    }

    _updateDetailsDataAndBusinessUnitData(campaignId, adgroupId, rowsData) {
        if (campaignId > 0 || adgroupId > 0) {
            // Se actualizo un objetivo. No cambia el bucc pero lo actualizamos igual porque adentor esta la campaña y facilita
            const buccRow = rowsData['campaigns_configuration'];
            const buccRowDashboard = buccRow["dashboard"];
            const buccId = parseInt(buccRow["id"], 10);
            const originalBuccDetailsData = this._getDetailsColumnDataForBusinessUnitAdAccount(buccId)

            if(campaignId > 0) {
                const campaignRow = rowsData['campaign'];
                const campaignRowDashboard = campaignRow["dashboard"];
                buccRowDashboard.campaigns_data = this.getNewCampaignDataForBuccId(originalBuccDetailsData, parseInt(campaignRowDashboard["id"], 10), campaignRowDashboard);
            } else if(adgroupId > 0) {
                const adgroupRow = rowsData['adgroup'];
                const adgroupRowDashboard = adgroupRow["dashboard"];

                // Si se está mostrando adgroups sin campaigns:
                if(originalBuccDetailsData.adgroups_data.length>0) {
                    buccRowDashboard.adgroups_data = this.getNewAdgroupDataForBuccId(originalBuccDetailsData, parseInt(adgroupRowDashboard["id"], 10), adgroupRowDashboard, originalBuccDetailsData.adgroups_data);
                } else {
                    const campaign_data = this.getCampaignDataOfAdgroupId(originalBuccDetailsData, adgroupId);
                    campaign_data.adgroups_data =  this.getNewAdgroupDataForBuccId(originalBuccDetailsData, parseInt(adgroupRowDashboard["id"], 10), adgroupRowDashboard, campaign_data.adgroups_data);
                    buccRowDashboard.campaigns_data = this.getNewCampaignDataForBuccId(originalBuccDetailsData, parseInt(campaign_data["id"], 10), campaign_data);
                }

            }
            const newDetailsData = this.updateDetailsForBuccId(buccId, buccRowDashboard);
            this.setState({
                detailsColumnData: newDetailsData
            });
        }

        this.props.onBusinessDataFetched(this.props.businessUnitId, rowsData["business_unit"]["dashboard"]);
    }

    handleAvailableFundsUpdated(businessUnitData) {
        this.props.onBusinessDataFetched(this.props.businessUnitId, businessUnitData);
    }

    handleOnlyActiveCampaignsOrAdgroupsChanged(buccId, showOnlyActive) {
        const newShowOnlyActiveCampaignsOrAdgroupsByBuccId =  this.state.showOnlyActiveCampaignsOrAdgroupsByBuccId;
        newShowOnlyActiveCampaignsOrAdgroupsByBuccId[buccId] = showOnlyActive;

        if(showOnlyActive !== true) {
            // Si nunca se trayeron las pausadas, las mando a cargar
            const detailsDataForBucc = this._getDetailsColumnDataForBusinessUnitAdAccount(buccId);
            if(detailsDataForBucc === null || detailsDataForBucc === undefined)
                return;

            const itemsLoaded = detailsDataForBucc["notActiveItemsLoaded"] === true;
            if (!itemsLoaded)
                this.fetchCampaignsAndAdgroupsNotActiveData(buccId);
        }

        this.setState({
            showOnlyActiveCampaignsOrAdgroupsByBuccId: newShowOnlyActiveCampaignsOrAdgroupsByBuccId
        });
    }

    // aux

    _rowCampaignClassName() {
        const className = this._rowClassName();
        return `campaign-row ${className}`
    }

    _rowAdgroupClassName() {
        const className = this._rowClassName();
        return `adgroup-row ${className}`
    }

    _rowClassName() {
        const isOddRow = this.props.rowOrderNumber % 2 === 1;
        const oddClass = isOddRow ? 'odd' : '';
        
        if (this._hasDownUrls()) {
            return `${oddClass} bu-alert false`.trim();
        }
        
        return oddClass;
    }

    _hasDownUrls() {
        return this.state.downUrlsCount > 0;
    }

    _numberOfColumns() {
        return this.props.activeColumns.length;
    }

    _businessUnitIsSnoozed() {
        if (this.props.businessUnitData !== null) {
            const anIndicatorData = this.props.businessUnitData[INDICATORS_COLUMNS[0]];
            // Se creo un presupuesto nuevo y anIndicatorData era undefined falló. Por eso se pone un parche acá
            // hasta que se reprodusca/solucione bien
            return anIndicatorData !== undefined ? anIndicatorData.alert_snoozed : false;
        } else {
            return false;
        }
    }

    _setBusinessUnitIsExpanded(value) {
        // FEDE: 2023-11: Deshabilitamos esto para que no le exigamos mucho al server-front. Que el usuario expanda la que quiere
        // localStorage.setItem(`BusinessUnitIsExpanded-${this.props.businessUnitId}`, value);
    }

    _setAdAccountIsExpanded(value, buccId) {
        // FEDE: 2023-11: Deshabilitamos esto para que no le exigamos mucho al server-front. Que el usuario expanda la que quiere
        // localStorage.setItem(`BusinessUnitIsExpanded-${this.props.businessUnitId}-${buccId}`, value);
    }

    _getBusinessUnitIsExpanded() {
        if (this._adAccountsRowsBeginExpanded === null) {
            const value = localStorage.getItem(`BusinessUnitIsExpanded-${this.props.businessUnitId}`);
            this._adAccountsRowsBeginExpanded = value !== null ? value === "true" : false;
        }
        return this._adAccountsRowsBeginExpanded;
    }

    // _getAdAccountIsExpanded(buccId) {
    //     const buccId_str = buccId.toString();
    //     if (!this.state.showingCampaignRowsByBuccId.hasOwnProperty(buccId_str)) {
    //         const value = localStorage.getItem(`BusinessUnitIsExpanded-${this.props.businessUnitId}-${buccId}`);
    //         this._campaignsRowsBeingExpanded[buccId_str] = value !== null ? value === "true" : false;
    //     }
    //     return this._campaignsRowsBeingExpanded[buccId_str];
    // }

    // render

    _renderCellsForActiveColumns(data, rowType, campaignsConfigurationId, campaignId, adgroupId) {
        if (data !== null) {

            if(rowType === TYPE_BUSINESS_UNIT && this._shouldRenderVeryOldDataLayer()) {
                return this._renderBusinessUnitWithVeryOldData();
            }

            const cols = this.props.activeColumns.map((columnId, index) => {
                return this._renderCellFor(columnId, data[columnId], index, rowType, campaignsConfigurationId, campaignId, adgroupId)
            });
            return cols;
        } else if (this.state.businessUnitNeverSynced) {
            return this._renderBusinessUnitNotSynced();
        } else if (this.state.businessUnitNotStarted) {
            return this._renderBusinessUnitNotStarted();
        } else if (this.state.businessUnitWithoutCampaignsConfiguration) {
            return this._renderBusinessUnitWithoutCampaignsConfiguration();
        } else {
            return this._renderLoader();
        }
    }

    _shouldRenderVeryOldDataLayer() {
        return this.state.syncInformation && this.state.syncInformation.has_sync_problems_for_a_long_time && this.state.showOldDataLayer;
    }

    _renderCellFor(columnName, columnData, key, rowType, campaignsConfigurationId, campaignId, adgroupId) {
        const { t } = this.props;
        const columnHeaderInfo = getColumnHeaderInformation(t);
        let cell = null;

        if (rowType === TYPE_CAMPAIGNS_CONFIGURATION && ONLY_FOR_BU_NOT_BUCC_COLUMN.includes(columnName))
            cell = <EmptyCell/>;
        else if ((rowType === TYPE_CAMPAIGN || rowType === TYPE_ADGROUP) && CAMPAIGN_AND_ADGROUP_ROW_EXCLUDED_COLUMNS.includes(columnName))
            cell = <EmptyCell/>;
        else if (TODAY_COLUMNS.includes(columnName)) {
            if(!columnData){
                cell = <SyncingCell />
            }
            else if (columnData.ordering_values !== undefined && columnData.formatted_value === undefined) {
                // Para BUCC de Analytics, las columnas de HOY vienen vacías con solo ordering_values y status
                cell = <EmptyCell />
            }
            else {
                cell = <DashboardTodayCell key={key} metricName={columnHeaderInfo[columnName]['title']}
                                           data={columnData}
                                           businessUnitId={this.props.businessUnitId}/>
            }
        } else if (columnName === DAYS_TILL_FUNDS_ARE_OUT_COLUMN) {
            cell = <DashboardValueWithAlertCell key={key} metricName={columnHeaderInfo[columnName]['title']}
                                                data={columnData}/>
        } else if (CURRENT_PERIOD_CPA_VS_COLUMNS.includes(columnName)) {
            cell = <DashboardCurrentCPAVsPeriodCell key={key} data={columnData} businessUnitId={this.props.businessUnitId}/>
        } else if (YESTERDAY_CPA_VS_COLUMNS.includes(columnName)) {
            cell = <DashboardYesterdayCPAVsPeriodCell key={key} data={columnData} businessUnitId={this.props.businessUnitId}/>
        } else if (columnName === CURRENT_PERIOD_COST_VS_TIME_COLUMN) {
            cell = <DashboardCurrentCostVsTimeCell key={key} data={columnData}/>
        } else if (columnName === FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN) {
            cell = <DashboardFullPeriodBudgetProportionalCell key={key} data={columnData}
                                                              rowType={rowType}
                                                              businessUnitId={this.props.businessUnitId}
                                                              />
        } else if (columnName === FULL_PERIOD_ODS_COLUMN) {
            cell = <DashboardFullPeriodODSCell key={key} data={columnData} businessUnitId={this.props.businessUnitId}/>
        } else if (columnName === YESTERDAY_EXPENSES_COLUMN || columnName === LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN) {
            cell = <DashboardFullPeriodYesterdayCell key={key} data={columnData} rowType={rowType}/>
        } else if (columnName === FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN ||
            columnName === FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN
        ) {
            cell = <DashboardFullPeriodODSVsSomethingCell key={key} data={columnData} businessUnitId={this.props.businessUnitId}/>
        } else if (columnName === FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN) {
            cell = <DashboardFullPeriodROASVsLastPeriodCell key={key} data={columnData} rowType={rowType}/>
        } else if (columnName === FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN) {
            cell = <DashboardFullPeriodACOSVsLastPeriodCell key={key} data={columnData} rowType={rowType}/>
        } else if (columnName === FULL_PERIOD_CONVERSIONS_COLUMN) {
            cell = <DashboardFullPeriodConversionsCell key={key} data={columnData} rowType={rowType} businessUnitId={this.props.businessUnitId}/>
        } else if (columnName === CURRENT_PERIOD_ALLOCATED_BUDGET_COLUMN) {
            cell = <DashboardBudgetCell key={key}
                                        formattedValue={columnData.formatted_value}
                                        value={columnData.value}
                                        status={columnData.status}
                                        budgetPartialGoals={columnData.partial_goals}
                                        periodType={columnData.period_type_enum}
                                        fromDate={DatetimeHelper.formatDateFromString(columnData.from_date)}
                                        toDate={DatetimeHelper.formatDateFromString(columnData.to_date)}
                                        businessUnitId={this.props.businessUnitId}
                                        campaignsConfigurationId={campaignsConfigurationId}
                                        campaignId={campaignId}
                                        adgroupId={adgroupId}
                                        clientName={this.props.clientName}
                                        businessUnitName={this.props.businessUnitName}
                                        budgetType={this.props.budgetType}
                                        onBudgetUpdated={this.handleBudgetUpdated}
                                        budgetIsNotSet={columnData.budget_is_not_set}
                                        rowType={rowType}
            />;
        } else if (columnName === CURRENT_PERIOD_PERIOD_DATES_COLUMN) {
            // Para que luego del deploy no se rompan los presupuesto que todavia no sincronizaron.
            if(!columnData)
                cell = <EmptyCell />;
            else {
                const data = {
                    "from_date": DatetimeHelper.formatDateFromString(columnData.from_date),
                    "to_date": DatetimeHelper.formatDateFromString(columnData.to_date),
                    "period_type": columnData.period_type_enum,
                    "item_schedule_configuration": columnData.item_schedule_configuration
                };

                const itemPeriodDates = new ItemPeriodDates(data);
                cell = <DashboardPeriodDatesCell key={key}
                                                 status={columnData.status}
                                                 clientName={this.props.clientName}
                                                 businessUnitId={this.props.businessUnitId}
                                                 businessUnitName={this.props.businessUnitName}
                                                 campaignsConfigurationId={campaignsConfigurationId}
                                                 campaignId={campaignId}
                                                 adgroupId={adgroupId}
                                                 rowType={rowType}
                                                 itemPeriodDates={itemPeriodDates}
                                                 onPeriodDatesUpdated={this.handlePeriodDatesUpdated}
                />;
            }
        } else if (columnName === AVAILABLE_FUNDS_COLUMN) {
            cell = <DashboardAvailableFundsCell key={key}
                                                status={columnData.status}
                                                formattedValue={columnData.formatted_value}
                                                value={columnData.value}
                                                businessUnitId={this.props.businessUnitId}
                                                onAvailableFundsUpdated={this.handleAvailableFundsUpdated}
                                                rowType={rowType}
            />;
        } else if (columnName === COMMENTS_COLUMN) {
            cell = <DashboardCommentsCell key={key}
                                          formattedValue={columnData.formatted_value}
                                          value={columnData.value}
                                          status={columnData.status}
                                          businessUnitId={this.props.businessUnitId}
                                          campaignsConfigurationId={campaignsConfigurationId}
                                          campaignId={campaignId}
                                          adgroupId={adgroupId}
                                          onCommentsUpdated={this.handleCommentsUpdated}
                                          rowType={rowType}
            />;
        } else if (columnName === PLATFORM_BUDGET_COLUMN) {
            cell = <PlatformBudgetCell key={key} platformBudget={columnData ? columnData.value : null} rowType={rowType} />;
        } else if (columnName === CAMPAIGN_STATUS_COLUMN) {
            cell = <CampaignStatusBadgeCell key={key} status={columnData ? columnData.value : null} rowType={rowType} />;
        } else if (LAST_PERIOD_BUDGET_DATA.includes(columnName) || CURRENT_PERIOD_BUDGET_DATA.includes(columnName) ||
            columnName === CURRENT_PERIOD_CPA_COLUMN || columnName === PURCHASES_VALUE_COLUMN ||
            columnName === ROAS_COLUMN || columnName === ACOS_COLUMN || columnName === LAST_PERIOD_PURCHASES_VALUE_COLUMN ||
            columnName === CURRENCY_COLUMN || columnName === CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN ||
            columnName === CURRENT_PERIOD_TIME_COMPLETION_COLUMN ||
            columnName === AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN
        ) {
            cell = <DashboardSingleValueCell key={key} value={columnData.formatted_value} status={columnData.status} />
        } else if (columnName === LABELS_COLUMN) {
            cell = <DashboardLabelsCell key={key}
                                        data={this.props.businessUnitLabels}
                                        businessUnitId={this.props.businessUnitId}
                                        onLabelsChange={this.props.onLabelsChange}
            />;
        } else if (columnName === GOAL_1_COLUMN || columnName === GOAL_2_COLUMN) {
            cell = <DashboardGoalBarsCell key={key}
                                          data={columnData}
                                          rowType={rowType}
                                          businessUnitId={this.props.businessUnitId}
                                          campaignsConfigurationId={campaignsConfigurationId}
                                          campaignId={campaignId}
                                          adgroupId={adgroupId}
                                          onGoalUpdated={this.handleGoalUpdated}
                                          priority={columnHeaderInfo[columnName]["priority"]}
            />;
        } else if (columnName === GOAL_1_INFO_COLUMN || columnName === GOAL_2_INFO_COLUMN) {
            // Para que luego del deploy no se rompan los presupuesto que todavia no sincronizaron.
            if(!columnData)
                cell = <EmptyCell />;
            else
                cell = <DashboardGoalGoalCell key={key}
                                              data={columnData}
                                              rowType={rowType}
                                              businessUnitId={this.props.businessUnitId}
                                              campaignsConfigurationId={campaignsConfigurationId}
                                              campaignId={campaignId}
                                              adgroupId={adgroupId}
                                              onGoalUpdated={this.handleGoalUpdated}
                                              priority={columnHeaderInfo[columnName]["priority"]}
                />;
        } else if (this.props.agencyFlexIndicators.includes(columnName) || (this.props.ga4Indicators != null && this.props.ga4Indicators.includes(columnName)) || (this.props.ecommerceIndicators != null && this.props.ecommerceIndicators.includes(columnName)) || (this.props.paidMediaIndicators != null && this.props.paidMediaIndicators.includes(columnName)) || (this.props.metaIndicators != null && this.props.metaIndicators.includes(columnName))) {
            const flexIndicatorData = FLEX_INDICATOR_COLUMN_TO_DATA(columnName)
            if (columnData === undefined || columnData === null) {
                cell = <SyncingCell />
            }
            else if(flexIndicatorData["vsPeriod"] === NO_COMPARATION_PERIOD){
                cell = <DashboardSingleValueCell key={key} value={columnData.fluctuation_formatted_value}  status={columnData.status}
                    columnData={columnData}
                    metricName={flexIndicatorData["metricName"]}
                />
            } else {
                cell = <DashboardValueVsExpectedCell key={key}
                                                     value={columnData.fluctuation_formatted_value}
                                                     status={columnData.status}
                                                     expectedValue={columnData.fluctuation_formatted_expected_value}
                                                     metricName={flexIndicatorData["metricName"]}
                                                     mainPeriod={getPeriodsData(t)[flexIndicatorData["mainPeriod"]]}
                                                     vsPeriod={getPeriodsData(t)[flexIndicatorData["vsPeriod"]]}
                                                     vsPeriodValue={columnData.fluctuation_formatted_vs_period_value}
                                                     alertLevel={columnData.alert_level}
                                                     alertSnoozed={columnData.alert_snoozed}
                                                     fluctuation={columnData.fluctuation}
                                                     fluctuationPercentage={columnData.fluctuation_formatted_percentage}
                                                     columnData={columnData}
                />;
            }
        }

        return (
            <CellWithErrorHandler key={key}>
                {cell}
            </CellWithErrorHandler>
        );
    }

    _renderBusinessUnitWithoutCampaignsConfiguration() {
        const { t } = this.props;
        return (
            <td colSpan={this._numberOfColumns()} className="row-loader">
                <p className="loader-message">{t('dashboard_row.control_line_no_accounts_or_campaigns')}</p>
            </td>
        );
    }

    _renderBusinessUnitWithVeryOldData() {
        const { t } = this.props;
        return (
            <td colSpan={this._numberOfColumns()} className="row-loader">
                <p className="loader-message">{t('dashboard_row.connection_problem_last_sync', {lastSync: this.state.syncInformation.last_sync})} <a href="#" onClick={(e) => { e.preventDefault(); this.setState({showOldDataLayer: false}); }}>{t('dashboard_row.want_to_see_row_anyway')}</a></p>
            </td>
        );
    }

    _renderBusinessUnitNotSynced() {
        const { t } = this.props;
        return (
            <td colSpan={this._numberOfColumns()} className="row-loader">
                <p className="loader-message">{t('dashboard_row.control_line_processing')}</p>
            </td>
        );
    }

    _renderBusinessUnitNotStarted() {
        const { t } = this.props;
        return (
            <td colSpan={this._numberOfColumns()} className="row-loader">
                <p className="loader-info-message">{t('dashboard_row.control_line_not_started')}</p>
            </td>
        );
    }


    _renderLoader(includeNameCell=false) {
        let numberOfColumns = this._numberOfColumns();
        if(includeNameCell)
            numberOfColumns += 1;

        return (
            <td colSpan={numberOfColumns} className="row-loader">
                <div className="loader"/>
            </td>
        );
    }

    _getDetailsColumnDataForBusinessUnitAdAccount(businessUnitAdAccountId) {
        const businessUnitAdAccountData = this.state.detailsColumnData !== null ? this.state.detailsColumnData.find(data => {
            return data !== null && data.id === businessUnitAdAccountId;
        }) : null;

        return businessUnitAdAccountData !== undefined ? businessUnitAdAccountData : null;
    }

    _renderCellsForActiveColumnsForBusinessUnitAdAccount(businessUnitAdAccountData) {
        const campaignsConfigurationId = businessUnitAdAccountData !== null? businessUnitAdAccountData.id : null;
        return this._renderCellsForActiveColumns(businessUnitAdAccountData, TYPE_CAMPAIGNS_CONFIGURATION, campaignsConfigurationId, null, null);
    }

    _renderBusinessUnitAdAccountsRows() {
        if (!this.state.showingAdAccountsRows)
            return;

        let rows = [];
        this.props.adAccountsData.forEach((data) => {
            const row = this._renderBusinessUnitAdAccountRow(data);
            rows.push(row);

            const campaignsRows = this._renderCampaignRows(data.id);
            rows = rows.concat(campaignsRows);

            const adgroupsRows = this._renderAdgroupRows(data.id);
            rows = rows.concat(adgroupsRows);

            if(this.state.loadingNotActiveCampaignsOrAdgroupByBuccId[data.id] === true)
            {
                const loadingRow = this._renderLoader(true);
                rows.push(loadingRow);
            }
        });



        return rows;
    }

    _renderCampaignRows(businessUnitAdAccountId) {
        // if (!this.state.showingCampaignRowsByBuccId[businessUnitAdAccountId.toString()])
        //     return;

        const businessUnitAdAccountData = this._getDetailsColumnDataForBusinessUnitAdAccount(businessUnitAdAccountId);
        if(businessUnitAdAccountData === null || businessUnitAdAccountData.campaigns_data === undefined)
            return;

        const rows = [];
        businessUnitAdAccountData.campaigns_data.forEach((campaign_data) => {

                if(campaign_data.status !== CAMPAIGN_STATUS_ACTIVE && this.state.showOnlyActiveCampaignsOrAdgroupsByBuccId[businessUnitAdAccountId] === true)
                    return;

                const row = this._renderCampaignRow(businessUnitAdAccountId, campaign_data);
                rows.push(row);

        });

        return rows;
    }

    _renderCampaignRow(campaignsConfigurationId, data) {
        const newCampaignsRows =[<tr className={this._rowCampaignClassName()} data-id={"campaign".concat(data.id)}>
            <CampaignNameCell
                campaignId={data.id}
                campaignName={data.name}
                onAdgroupsDataToggle={this.handleToggleAdgroupsRows}
                status={data.status}
                hasAdgroupsData={data.adgroups_data !== null && data.adgroups_data !== undefined && data.adgroups_data.length > 0}

            />
            {this._renderCellsForActiveColumns(data, TYPE_CAMPAIGN, campaignsConfigurationId, data.id, null)}
        </tr>];

        // Se agregan las filas de los adgroups
        if(this.state.showingAdgroupsRowsByCampaignId[data.id] !== undefined && this.state.showingAdgroupsRowsByCampaignId[data.id] && data.adgroups_data)  {
            data.adgroups_data.forEach((adgroup_data) => {
                newCampaignsRows.push(this._renderAdgroupRow(campaignsConfigurationId, adgroup_data, true));
            });
        }

        return newCampaignsRows;
    }

    _renderAdgroupRows(businessUnitAdAccountId) {
        // if (!this.state.showingCampaignRowsByBuccId[businessUnitAdAccountId.toString()])
        //     return;

        const businessUnitAdAccountData = this._getDetailsColumnDataForBusinessUnitAdAccount(businessUnitAdAccountId);
        if(businessUnitAdAccountData === null || businessUnitAdAccountData.adgroups_data === undefined)
            return;

        const rows = [];
        businessUnitAdAccountData.adgroups_data.forEach((adgroup_data) => {

                if(adgroup_data.status !== ADGROUP_STATUS_ACTIVE && this.state.showOnlyActiveCampaignsOrAdgroupsByBuccId[businessUnitAdAccountId] === true)
                    return;

                const row = this._renderAdgroupRow(businessUnitAdAccountId, adgroup_data, false);
                rows.push(row);

        });

        return rows;
    }

    _renderAdgroupRow(campaignsConfigurationId, data, insideCampaignRow) {
        return <tr className={this._rowAdgroupClassName()} data-id={"adgroup".concat(data.id)}>
            <AdgroupNameCell
                adgroupId={data.id}
                adgroupName={data.name}
                status={data.status}
                campaignName={data.campaign_name}
                insideCampaignRow={insideCampaignRow}
            />
            {this._renderCellsForActiveColumns(data, TYPE_ADGROUP, campaignsConfigurationId, null, data.id)}
        </tr>;
    }

    _renderBusinessUnitAdAccountRow(data) {
        const businessUnitAdAccountData = this._getDetailsColumnDataForBusinessUnitAdAccount(data.id);
        // Si el BU es a nivel campaña entonces dejo ver Pausadas
        const showNotActiveItems = (this.props.businessUnitType === TYPE_ONE_BUDGET_PER_CAMPAIGN || this.props.businessUnitType === TYPE_ONE_BUDGET_PER_ADGROUP);
        const showFilter = businessUnitAdAccountData !== null && showNotActiveItems;
        const channelHasCampaignOrAdgroupLevel = ChannelsHelper.channelHasCampaignOrAdgroupLevel(data.channel);
        const showOnlyActiveLabel = businessUnitAdAccountData !== null && !showNotActiveItems && channelHasCampaignOrAdgroupLevel;


        return <tr className={this._rowClassName()} data-id={"bucc".concat(data.id)}>
            <BusinessUnitAdAccountNameCell
                buccId={data.id}
                channel={data.channel}
                accountId={data.account_id}
                accountName={data.name}
                // onCampaignsDataToggle={() => (this.handleToggleCampaignsRows(data.id))}
                onOnlyActiveCampaignsChange={this.handleOnlyActiveCampaignsOrAdgroupsChanged}
                // campaignsRowsExpanded={this.state.showingCampaignRowsByBuccId[data.id.toString()]}
                generalAlerts={this.props.generalAlerts}
                showFilter={showFilter}
                showOnlyActiveLabel={showOnlyActiveLabel}
            />
            {this._renderCellsForActiveColumnsForBusinessUnitAdAccount(businessUnitAdAccountData)}
        </tr>;
    }

    render() {
        return (
            <React.Fragment>
                <tr className={this._rowClassName()} data-id={this.props.businessUnitId}>
                    <BusinessUnitNameCell businessUnitId={this.props.businessUnitId}
                                          businessUnitName={this.props.businessUnitName}
                                          adAccountsData={this.props.adAccountsData}
                                          hasDownUrls={this._hasDownUrls()}
                                          downUrlsCount={this.state.downUrlsCount}
                                          hasUrls={this.state.hasUrls}
                                          channels={this.props.channels}
                                          clientId={this.props.clientId}
                                          clientName={this.props.clientName}
                                          businessUnitLabels={this.props.businessUnitLabels}
                                          onLabelsChange={this.props.onLabelsChange}
                                          isSnoozed={this._businessUnitIsSnoozed()}
                                          onSnoozeAllAlerts={this.handleSnoozeAllAlerts}
                                          onStopSnoozeForAllAlerts={this.handleStopSnoozeForAllAlerts}
                                          generalAlerts={this.props.generalAlerts}
                                          syncInformation={this.state.syncInformation}
                                          onBusinessUnitSync={this.handleBusinessUnitSync}
                                          hasAdAccountsDataToShow={this.props.hasAdAccountsDataToShow}
                                          onAdAccountsDataToggle={this.handleToggleAdAccountsRows}
                                          AdAccountsRowsExpanded={this._getBusinessUnitIsExpanded()}
                                          location={this.props.location}
                    />
                    {this._renderCellsForActiveColumns(this.props.businessUnitData, TYPE_BUSINESS_UNIT, null, null, null)}
                    <WebSocketEvent eventId={WebSocketEvents.BU_DASHBOARD_SYNCED}
                                    channelId={WebSocketChannels.BU_DASHBOARD_SYNC}
                                    onEventTriggered={this.handleWebSocketDataUpdateRequest}
                    />
                    <WebSocketEvent eventId={WebSocketEvents.URL_STATUS_CHANGE}
                                    channelId={WebSocketChannels.URL_STATUS_CHANGE}
                                    onEventTriggered={this.handleURLStatusChange}
                    />
                </tr>
                {this._renderBusinessUnitAdAccountsRows()}
            </React.Fragment>
        )
    }
}

export const DashboardRow = withTranslation()(DashboardRowClass);
export default DashboardRow;
